import { defineMessages } from 'react-intl'

export const PROFILE_TRAINING_FREQUENCY = {
  NOT_ACTIVE: 1,
  OCCASIONALLY: 2,
  FREQUENTLY: 3,
  VERY_FREQUENTLY: 4
}
export const PROFILE_TRAINING_FREQUENCIES = Object.values(PROFILE_TRAINING_FREQUENCY)

export const PROFILE_TRAINING_FREQUENCY_EMOJI = {
  [PROFILE_TRAINING_FREQUENCY.NOT_ACTIVE]: '🛋️',
  [PROFILE_TRAINING_FREQUENCY.OCCASIONALLY]: '🚶',
  [PROFILE_TRAINING_FREQUENCY.FREQUENTLY]: '🏃',
  [PROFILE_TRAINING_FREQUENCY.VERY_FREQUENTLY]: '🏋️'
}

const messages = defineMessages({
  notActive: {
    id: 'trainingFrequency.notActive',
    defaultMessage: 'Not Active',
    description: 'The message used for the notActive training frequency.'
  },
  occasionally: {
    id: 'trainingFrequency.occasionally',
    defaultMessage: 'Occasionally',
    description: 'The message used for the occasionally training frequency.'
  },
  frequently: {
    id: 'trainingFrequency.frequently',
    defaultMessage: 'Frequently',
    description: 'The message used for the frequently training frequency.'
  },
  veryFrequently: {
    id: 'trainingFrequency.veryFrequently',
    defaultMessage: 'Frequently+',
    description: 'The message used for the very frequently training frequency.'
  }
})

const messageHelper = defineMessages({
  notActive: {
    id: 'trainingFrequencyHelper.notActive',
    defaultMessage: '0 workout/week',
    description: 'The message used for the notActive training frequency.'
  },
  occasionally: {
    id: 'trainingFrequencyHelper.occasionally',
    defaultMessage: '1-3 workout/week',
    description: 'The message used for the occasionally training frequency.'
  },
  frequently: {
    id: 'trainingFrequencyHelper.frequently',
    defaultMessage: '3-5 workout/week',
    description: 'The message used for the frequently training frequency.'
  },
  veryFrequently: {
    id: 'trainingFrequencyHelper.veryFrequently',
    defaultMessage: '5+ workout/week',
    description: 'The message used for the very frequently training frequency.'
  }
})

export const PROFILE_TRAINING_FREQUENCY_MESSAGE = {
  [PROFILE_TRAINING_FREQUENCY.NOT_ACTIVE]: messages.notActive,
  [PROFILE_TRAINING_FREQUENCY.OCCASIONALLY]: messages.occasionally,
  [PROFILE_TRAINING_FREQUENCY.FREQUENTLY]: messages.frequently,
  [PROFILE_TRAINING_FREQUENCY.VERY_FREQUENTLY]: messages.veryFrequently
}

export const PROFILE_TRAINING_FREQUENCY_MESSAGE_HELPER = {
  [PROFILE_TRAINING_FREQUENCY.NOT_ACTIVE]: messageHelper.notActive,
  [PROFILE_TRAINING_FREQUENCY.OCCASIONALLY]: messageHelper.occasionally,
  [PROFILE_TRAINING_FREQUENCY.FREQUENTLY]: messageHelper.frequently,
  [PROFILE_TRAINING_FREQUENCY.VERY_FREQUENTLY]: messageHelper.veryFrequently
}
